import { TweenLite, Power2 } from 'gsap'

import normalizeWheel from 'normalize-wheel'

import EventHubMixin from '@/mixins/EventHub.js'
import APIMixin from '@/mixins/API.js'
import ScrollMixin from '@/mixins/Scroll.js'
import SizesMixin from '@/mixins/Sizes.js'
import TimeMixin from '@/mixins/Time.js'

import AppPicture from '@/components/app-picture'
import AppIconArrow from '@/components/app-icon-arrow'
import AppIconPlay from '@/components/app-icon-play'

export default
{
    name: 'app-page-chapter',

    mixins:
    [
        EventHubMixin,
        APIMixin,
        ScrollMixin,
        SizesMixin,
        TimeMixin
    ],

    components:
    {
        AppPicture,
        AppIconArrow,
        AppIconPlay
    },

    data()
    {
        return {
            chapter: null,
            content: null,
            otherChapters: null,
            revealContents: false,
            storySize: 1,
            grabbing: false,
            storiesTextVisible: false,
            introVisible: false
        }
    },

    created()
    {
        this.storySize = Math.round(this.sizes.viewport.height * 0.36)
        this.revealContents = window.scrollY > 5 || this.sizes.width >= 1024

        // All fetch callback
        const allFetchCallback = () =>
        {
            this.$nextTick(() =>
            {
                // Header logo
                this.$eventHub.$emit('headerLogo.setState', { state: 'back', backText: this.content.acf.label_chapters, backTo: { name: `${this.$route.meta.lang}_chapters` } })

                this.setIntro()
                this.setNavigation()
                this.onResize(false)
            })
        }

        // Fetch content
        this.fetch('pages', { slug: 'chapters', per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || data.length < 1)
            {
                this.$router.push({ name: '404' })
                return
            }

            this.content = data[0]

            if(this.content && this.chapter)
            {
                // Papillon
                window.dispatchEvent(new Event('papillon'))

                allFetchCallback()
            }
        })

        // Fetch chapters
        // Fetch all to find the next one and use the result to find the current one
        this.fetch('chapters', { per_page: 1000 }, (data, error) =>
        {
            // Error
            if(error === true || data.length < 1)
            {
                this.$router.push({ name: '404' })
                return
            }

            // Current chapter
            this.chapter = data.find((_chapter) => _chapter.acf.slug === this.$route.params.chapterSlug)
            console.log('this.chapter', this.chapter)

            // Error
            if(!this.chapter)
            {
                this.$router.push({ name: '404' })
                return
            }

            // SEO
            document.title = this.chapter.acf.seo_title ? this.chapter.acf.seo_title : this.chapter.acf.title.replace(/<br ?\/?>/gi, '')
            if(this.chapter.acf.seo_description)
            {
                document.querySelector('meta[name=description]').content = this.chapter.acf.seo_description
            }

            // Other chapters
            this.otherChapters = data.filter((_chapter) => _chapter.acf.slug !== this.$route.params.chapterSlug)

            if(this.content && this.chapter)
            {
                // Papillon
                this.$nextTick(() =>
                {
                    window.dispatchEvent(new Event('papillon'))
                })

                allFetchCallback()
            }
        }, this.$root.isFirstPage())
    },

    mounted()
    {
        this.$introTexts = this.$refs.introTexts

        // Stroke
        this.strokes = {}

        this.strokes.blue = {}
        this.strokes.blue.x = 0
        this.strokes.blue.length = 0
        this.strokes.blue.lineWidth = 1
        this.strokes.blue.strokeStyle = '#3092d0'

        this.strokes.white = {}
        this.strokes.white.x = 0
        this.strokes.white.length = 0
        this.strokes.white.lineWidth = 1
        this.strokes.white.strokeStyle = '#ffffff'

        this.$eventHub.$emit('line.createStroke', this.strokes.blue)
        this.$eventHub.$emit('line.createStroke', this.strokes.white)

        TweenLite.to(this.strokes.blue, 1, { length: this.sizes.width * 0.1, ease: Power2.easeOut })
        TweenLite.to(this.strokes.white, 1, { length: this.sizes.width * 0.1, ease: Power2.easeOut })

        // Line
        this.$eventHub.$emit('line.setElement', this.$refs.lineMark, false)
        this.$eventHub.$emit('line.moveToElement', false, 0.01)
        // const dummy = { value: 0 }
        // TweenLite.to(dummy, 2, { value:  })

        // Listen to window scroll event
        window.addEventListener('scroll', this.onScroll, { passive: true })

        // Scroll progress
        this.scrollProgress = {}

        this.scrollProgress.progress = 0

        this.scrollProgress.$background = this.$refs.scrollProgressBackground
        this.scrollProgress.$value = this.$refs.scrollProgressValue
        this.scrollProgress.$ease = this.$refs.scrollProgressEase
        this.scrollProgress.$arrow = this.$refs.scrollProgressArrow

        this.scrollProgress.measures = {}
        this.scrollProgress.measures.limitTop = 180
        this.scrollProgress.measures.limitDown = 80

        this.scrollProgress.measures.top = 70
        this.scrollProgress.measures.bottom = 70

        this.scrollProgress.measures.height = 1
        this.scrollProgress.measures.scrollY = 0

        this.scrollProgress.measures.value = {}

        this.scrollProgress.measures.value.y = {}
        this.scrollProgress.measures.value.y.value = 0
        this.scrollProgress.measures.value.y.target = 0
        this.scrollProgress.measures.value.y.rounded = 0

        this.scrollProgress.measures.value.scale = {}
        this.scrollProgress.measures.value.scale.value = 0
        this.scrollProgress.measures.value.scale.target = 0
        this.scrollProgress.measures.value.scale.rounded = 0

        this.scrollProgress.measures.ease = {}

        this.scrollProgress.measures.ease.y = {}
        this.scrollProgress.measures.ease.y.value = 0
        this.scrollProgress.measures.ease.y.target = 0
        this.scrollProgress.measures.ease.y.rounded = 0

        this.scrollProgress.measures.ease.scale = {}
        this.scrollProgress.measures.ease.scale.value = 0
        this.scrollProgress.measures.ease.scale.target = 0
        this.scrollProgress.measures.ease.scale.rounded = 0

        this.scrollProgress.measures.background = {}

        this.scrollProgress.measures.background.y = {}
        this.scrollProgress.measures.background.y.value = 0
        this.scrollProgress.measures.background.y.target = 0
        this.scrollProgress.measures.background.y.rounded = 0

        this.scrollProgress.measures.background.scale = {}
        this.scrollProgress.measures.background.scale.value = 0
        this.scrollProgress.measures.background.scale.target = 0
        this.scrollProgress.measures.background.scale.rounded = 0
    },

    beforeDestroy()
    {
        this.$el.classList.add('leaving')
    },

    destroyed()
    {
        let $eventHub = this.$eventHub
        let strokes = this.strokes

        TweenLite.to(this.strokes.blue, 1, { x: this.sizes.width, length: 30, ease: Power2.easeInOut, onComplete()
        {
            $eventHub.$emit('line.deleteStroke', strokes.blue)
        } })

        TweenLite.to(this.strokes.white, 1, { x: this.sizes.width, length: 30, ease: Power2.easeInOut, onComplete()
        {
            $eventHub.$emit('line.deleteStroke', strokes.white)
            $eventHub = null
            strokes = null
        } })

        // Remove events
        window.removeEventListener('scroll', this.onScroll)
        document.removeEventListener('touchstart', this.navigation.touchstart)

        let wheelEvent
        if('onwheel' in document)
        {
            wheelEvent = 'wheel'
        }
        else if(document.onmousewheel !== undefined)
        {
            wheelEvent = 'mousewheel'
        }
        else
        {
            wheelEvent = 'DOMMouseScroll'
        }

        document.removeEventListener(wheelEvent, this.navigation.wheel)

        this.navigation.$content.removeEventListener('mousedown', this.navigation.mousedown)
        this.navigation.$content.removeEventListener('click', this.navigation.click)
    },

    methods:
    {
        setIntro()
        {
            const $pictures = this.$refs.storyPictures
            const $continue = this.$refs.continue
            const $stories = [...this.$refs.stories, $continue]
            const toLoad = $pictures.length
            let loaded = 0

            $continue.classList.add('visible')

            let i = 0
            let zIndex = 0
            for(const $picture of $pictures)
            {
                const $story = $stories[i]
                const delay = ($pictures.length - 1 - i) / 7

                const pictureLoadedCallback = () =>
                {
                    loaded++

                    window.setTimeout(() =>
                    {
                        $story.classList.add('visible')
                        $story.style.zIndex = ++zIndex
                    }, 1000 * delay)

                    if(loaded === toLoad)
                    {
                        this.introVisible = true

                        window.setTimeout(() =>
                        {
                            this.storiesTextVisible = true
                        }, 2250)
                    }

                    $picture.$off('loading-end', pictureLoadedCallback)
                }
                $picture.$on('loading-end', pictureLoadedCallback)

                i++
            }
        },

        setNavigation()
        {
            // Test if not ready or already set
            if(!this.chapter || !this.content || this.navigation)
            {
                return
            }

            // Set up
            this.navigation = {}

            this.navigation.active = false
            this.navigation.enoughSpace = false

            this.navigation.scroll = {}
            this.navigation.scroll.target = 0
            this.navigation.scroll.current = 0
            this.navigation.scroll.rounded = 0
            this.navigation.scroll.min = 0
            this.navigation.scroll.max = 0

            this.navigation.$container = this.$refs.container
            this.navigation.$content = this.$refs.content

            this.navigation.containerWidth = 0
            this.navigation.contentWidth = 0

            // Scroll events
            this.navigation.wheel = (_event) =>
            {
                _event.preventDefault()

                const normalized = normalizeWheel(_event)
                const value = Math.abs(normalized.pixelX) > Math.abs(normalized.pixelY) ? normalized.pixelX : normalized.pixelY
                this.navigation.scroll.target += value

                this.navigation.scroll.target = Math.min(Math.max(this.navigation.scroll.target, this.navigation.scroll.min), this.navigation.scroll.max)
            }

            let wheelEvent
            if('onwheel' in document)
            {
                wheelEvent = 'wheel'
            }
            else if(document.onmousewheel !== undefined)
            {
                wheelEvent = 'mousewheel'
            }
            else
            {
                wheelEvent = 'DOMMouseScroll'
            }

            document.addEventListener(wheelEvent, this.navigation.wheel)

            // Touch events
            let touchX = 0
            this.navigation.touchstart = (_event) =>
            {
                touchX = _event.touches[0].pageX

                document.addEventListener('touchmove', this.navigation.touchmove)
                document.addEventListener('touchend', this.navigation.touchend)
            }
            this.navigation.touchmove = (_event) =>
            {
                this.navigation.scroll.target -= _event.touches[0].pageX - touchX
                touchX = _event.touches[0].pageX

                this.navigation.scroll.target = Math.min(Math.max(this.navigation.scroll.target, this.navigation.scroll.min), this.navigation.scroll.max)
            }
            this.navigation.touchend = () =>
            {
                document.removeEventListener('touchmove', this.navigation.touchmove)
                document.removeEventListener('touchend', this.navigation.touchend)
            }

            document.addEventListener('touchstart', this.navigation.touchstart)

            // Mouse events
            const mouse = { x: 0, y: 0, original: { x: 0, y: 0 } }
            this.navigation.mousedown = (_event) =>
            {
                _event.preventDefault()

                this.grabbing = true

                mouse.x = _event.clientX
                mouse.y = _event.clientY
                mouse.original.x = mouse.x
                mouse.original.y = mouse.y

                document.addEventListener('mousemove', this.navigation.mousemove)
                document.addEventListener('mouseup', this.navigation.mouseup)
            }
            this.navigation.mousemove = (_event) =>
            {
                _event.preventDefault()

                this.navigation.scroll.target -= _event.clientX - mouse.x
                mouse.x = _event.clientX
                mouse.y = _event.clientY

                this.navigation.scroll.target = Math.min(Math.max(this.navigation.scroll.target, this.navigation.scroll.min), this.navigation.scroll.max)
            }
            this.navigation.mouseup = () =>
            {
                this.grabbing = false

                document.removeEventListener('mousemove', this.navigation.mousemove)
                document.removeEventListener('mouseup', this.navigation.mouseup)
            }
            this.navigation.click = (_event) =>
            {
                const distance = Math.hypot(mouse.x - mouse.original.x, mouse.y - mouse.original.y)

                if(distance > 15)
                {
                    _event.stopPropagation()
                    _event.preventDefault()
                }
            }

            this.navigation.$content.addEventListener('mousedown', this.navigation.mousedown)
            this.navigation.$content.addEventListener('click', this.navigation.click, true)
        },

        onScroll()
        {
            this.revealContents = window.scrollY > 5 || this.sizes.width >= 1024
            this.scrollProgress.measures.scrollY = window.scrollY
        },

        onResize()
        {
            const referenceSize = (this.sizes.viewport.height > this.sizes.viewport.width || this.sizes.width >= 1024) ? this.sizes.viewport.height : this.sizes.viewport.width
            this.storySize = Math.round(referenceSize * 0.36)

            this.scrollProgress.measures.height = this.$el.offsetHeight
            this.scrollProgress.measures.limitTop = this.$introTexts.offsetHeight

            // Navigation
            if(this.navigation)
            {
                this.navigation.active = this.sizes.width >= 1024

                if(this.navigation.active)
                {
                    this.navigation.containerWidth = this.navigation.$container.offsetWidth
                    this.navigation.contentWidth = this.navigation.$content.offsetWidth

                    const enoughSpace = this.navigation.contentWidth <= this.navigation.containerWidth

                    if(enoughSpace !== this.navigation.enoughSpace)
                    {
                        this.navigation.enoughSpace = enoughSpace

                        if(this.navigation.enoughSpace)
                        {
                            this.navigation.$container.classList.add('enough-space')
                        }
                        else
                        {
                            this.navigation.$container.classList.remove('enough-space')
                        }
                    }

                    this.navigation.$content.style.transform = 'translateX(0px)'

                    if(!this.navigation.enoughSpace)
                    {
                        this.navigation.scroll.max = this.navigation.contentWidth - this.navigation.containerWidth
                    }
                }
            }
        },

        onTick()
        {
            const progress = this.scrollProgress.measures.scrollY / (this.scrollProgress.measures.height - this.sizes.viewport.height)
            const direction = progress > this.scrollProgress.progress ? 'down' : 'up'
            this.scrollProgress.progress = progress
            let state = 'middle'

            if(this.scrollProgress.measures.scrollY < this.scrollProgress.measures.limitTop)
            {
                state = 'top'
            }
            if(this.scrollProgress.measures.scrollY > this.scrollProgress.measures.height - this.sizes.viewport.height - this.scrollProgress.measures.limitDown)
            {
                state = 'bottom'
            }

            // Top / Bottom
            if(state === 'top')
            {
                this.scrollProgress.measures.top = this.sizes.viewport.height - 70
                this.scrollProgress.measures.bottom = this.sizes.viewport.height - 30
            }
            else if(state === 'middle')
            {
                this.scrollProgress.measures.top = 80
                this.scrollProgress.measures.bottom = this.sizes.viewport.height - 70
            }
            else if(state === 'bottom')
            {
                this.scrollProgress.measures.top = this.sizes.viewport.height - 110
                this.scrollProgress.measures.bottom = this.sizes.viewport.height - 70
            }

            // Background
            this.scrollProgress.measures.background.scale.target = state === 'top' ? ((this.sizes.viewport.height - this.scrollProgress.measures.top - (this.sizes.viewport.height - this.scrollProgress.measures.bottom)) / this.sizes.viewport.height) : 1
            this.scrollProgress.measures.background.scale.value += (this.scrollProgress.measures.background.scale.target - this.scrollProgress.measures.background.scale.value) * this.time.delta * 0.01
            this.scrollProgress.measures.background.scale.rounded = Math.round(this.scrollProgress.measures.background.scale.value * 1000) / 1000

            this.scrollProgress.measures.background.y.target = state === 'top' ? this.scrollProgress.measures.top : 0
            this.scrollProgress.measures.background.y.value += (this.scrollProgress.measures.background.y.target - this.scrollProgress.measures.background.y.value) * this.time.delta * 0.01
            this.scrollProgress.measures.background.y.rounded = Math.round(this.scrollProgress.measures.background.y.value * 1000) / 1000

            this.scrollProgress.$background.style.transform = `translateY(${this.scrollProgress.measures.background.y.rounded}px) scaleY(${this.scrollProgress.measures.background.scale.rounded})`

            // Value
            this.scrollProgress.measures.value.scale.target = ((state === 'top' || state === 'bottom') ? 0.5 : this.scrollProgress.progress) * ((this.sizes.viewport.height - this.scrollProgress.measures.top - (this.sizes.viewport.height - this.scrollProgress.measures.bottom)) / this.sizes.viewport.height)
            this.scrollProgress.measures.value.scale.value += (this.scrollProgress.measures.value.scale.target - this.scrollProgress.measures.value.scale.value) * this.time.delta * (state === 'top' || state === 'bottom' ? 0.01 : (direction === 'down' ? 0.01 : 0.004))
            this.scrollProgress.measures.value.scale.rounded = Math.round(this.scrollProgress.measures.value.scale.value * 1000) / 1000

            this.scrollProgress.measures.value.y.target = (state === 'top' || state === 'bottom') ? this.scrollProgress.measures.top + (this.scrollProgress.measures.bottom - this.scrollProgress.measures.top) * 0.25 : this.scrollProgress.measures.top
            this.scrollProgress.measures.value.y.value += (this.scrollProgress.measures.value.y.target - this.scrollProgress.measures.value.y.value) * this.time.delta * 0.01
            this.scrollProgress.measures.value.y.rounded = Math.round(this.scrollProgress.measures.value.y.value * 1000) / 1000

            this.scrollProgress.$value.style.transform = `translateY(${this.scrollProgress.measures.value.y.rounded}px) scaleY(${this.scrollProgress.measures.value.scale.rounded})`

            // Ease
            this.scrollProgress.measures.ease.scale.target = ((state === 'top' || state === 'bottom') ? 0.125 : this.scrollProgress.progress) * ((this.sizes.viewport.height - this.scrollProgress.measures.top - (this.sizes.viewport.height - this.scrollProgress.measures.bottom)) / this.sizes.viewport.height)
            this.scrollProgress.measures.ease.scale.value += (this.scrollProgress.measures.ease.scale.target - this.scrollProgress.measures.ease.scale.value) * this.time.delta * (state === 'top' || state === 'bottom' ? 0.01 : (direction === 'down' ? 0.004 : 0.01))
            this.scrollProgress.measures.ease.scale.rounded = Math.round(this.scrollProgress.measures.ease.scale.value * 1000) / 1000

            this.scrollProgress.measures.ease.y.target = (state === 'top' || state === 'bottom') ? this.scrollProgress.measures.top + (this.scrollProgress.measures.bottom - this.scrollProgress.measures.top) * 0.25 : this.scrollProgress.measures.top
            this.scrollProgress.measures.ease.y.value += (this.scrollProgress.measures.ease.y.target - this.scrollProgress.measures.ease.y.value) * this.time.delta * 0.01
            this.scrollProgress.measures.ease.y.rounded = Math.round(this.scrollProgress.measures.ease.y.value * 1000) / 1000

            this.scrollProgress.$ease.style.transform = `translateY(${this.scrollProgress.measures.ease.y.rounded}px) scaleY(${this.scrollProgress.measures.ease.scale.rounded})`

            // Arrow
            this.scrollProgress.$arrow.style.transform = `translateY(${this.scrollProgress.measures.value.y.rounded + (this.scrollProgress.measures.value.scale.rounded * this.sizes.viewport.height)}px)`
            this.scrollProgress.$arrow.style.opacity = state === 'middle' ? 0 : 1

            // Navigation
            if(this.navigation && this.navigation.active)
            {
                this.navigation.scroll.current += (this.navigation.scroll.target - this.navigation.scroll.current) * this.time.delta * 0.01

                const rounded = Math.round(this.navigation.scroll.current * 100) / 100

                if(rounded !== this.navigation.scroll.rounded)
                {
                    this.navigation.scroll.rounded = rounded
                    this.navigation.$content.style.transform = `translateX(${- this.navigation.scroll.rounded}px)`
                }

                // Stroke
                if(!this.navigation.enoughSpace)
                {
                    const strokeMaxLength = this.sizes.width * 0.1 + (this.sizes.width * 0.8) * (this.navigation.scroll.current / this.navigation.scroll.max)
                    this.strokes.blue.length += (strokeMaxLength - this.strokes.blue.length) * 0.1
                    this.strokes.white.length += (strokeMaxLength - this.strokes.white.length) * 0.05
                }
            }
        },

        onPreviewClick()
        {
            this.animateTo(this.sizes.viewport.height - 150, 1)
        },

        onVideoClick(video)
        {
            // Open URL
            if(video.url)
            {
                window.open(video.url, '_blank')
            }

            // Open player
            else
            {
                this.$eventHub.$emit('player.activate', video.ID)
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-page-chapter/script.js